(function () {
  'use strict';

  angular
    .module('quadroOcorrencias', [
      'ui.router',
      'ocorrencia.component',
      'httpServiceV3gModule',
      'angularMoment',
      'enumModule',
      'ConstantVfiltroModule',
      'v3gAuthenticatorModule',
      'ui.bootstrap.modal',
      'ServiceVfiltroModule',
      'alert-message',
      'ObjetosVfiltroModule',
      'FactoryVfiltroModule',
      'pascalprecht.translate',
      'modalInfoConfirmModule',
      'AlertasModule'
    ]);
}());
